var exports = {
  "kL": "VoiceStateIcons.module__container___dERhem",
  "Kk": "VoiceStateIcons.module__icon___dERhem",
  "bU": "VoiceStateIcons.module__iconMuted___dERhem",
  "DP": "VoiceStateIcons.module__iconGuildAction___dERhem",
};

module.exports = exports;
